import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { useStore } from 'src/stores';
import { TagModalUnit } from './unit';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BackdropLoader, Icon } from '@livable/saas-react-components';
export const TagModalForm = observer(() => {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  const store = useStore();
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    inProgress = _useState2[0],
    setInProgress = _useState2[1];
  const handleDelete = async id => {
    setInProgress(false);
    await store.tags.deleteTagAsync.run({
      tagId: id
    });
    setTimeout(() => {
      store.tags.deleteTag(id);
      setInProgress(true);
    }, 100);
  };
  const handleEdit = async id => {
    setInProgress(false);
    await store.tags.updateTagAsync.run({
      tagId: id,
      name: store.tags.getEditableTagById(id).name,
      color: store.tags.getEditableTagById(id).color
    });
    setTimeout(() => {
      setInProgress(true);
    }, 100);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "warning",
    type: "alert"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('admin_page.changes_saved_immediately'))), store.tags.editableTagsList.map(i => /*#__PURE__*/React.createElement(TagModalUnit, {
    data: i,
    handleEdit: handleEdit,
    handleDelete: handleDelete
  }))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: !inProgress || store.tags.createTagAsync.inProgress || store.tags.getAllTagsAsync.inProgress || store.tags.updateTagAsync.inProgress || store.tags.deleteTagAsync.inProgress || store.tags.getTagByIdAsync.inProgress || store.tags.assignTagsToAccountAsync.inProgress || store.tags.removeTagsFromAccountAsync.inProgress || store.tags.getAllTagsByAccountIdsAsync.inProgress
  }));
});